// Generated by BUCKLESCRIPT, PLEASE EDIT WITH CARE

import * as React from "react";
import * as Link$Xuder from "../components/Link.bs.js";
import * as ReactTyped from "react-typed";
import * as Button$Xuder from "../components/Button.bs.js";

require("./HomePage.css");

function HomePage(Props) {
  return React.createElement("div", {
              className: "landing-page single-page"
            }, React.createElement("div", {
                  className: "content"
                }, React.createElement("h1", undefined, "Omonib"), React.createElement("h3", undefined, React.createElement(ReactTyped.default, {
                          strings: /* array */[
                            "Compose",
                            "Create",
                            "Plan",
                            "Evaluate"
                          ],
                          typeSpeed: 50,
                          backSpeed: 40,
                          loop: true,
                          showCursor: false
                        }), " your contract"), React.createElement(Link$Xuder.make, {
                      route: "/compose",
                      children: React.createElement(Button$Xuder.make, {
                            children: "Compose now"
                          })
                    })));
}

var make = HomePage;

export {
  make ,
  
}
/*  Not a pure module */
